import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { setTokens, AUTH_URL } from '../auth';
import './Login.css';

function getStoredTheme() {
  try { return localStorage.getItem('theme') || 'dark'; } catch { return 'dark'; }
}

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', getStoredTheme());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(AUTH_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.detail || 'Invalid username or password');
        return;
      }
      setTokens(data.access, data.refresh);
      onLogin();
    } catch {
      setError('Could not connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="login__card">
        <div className="login__brand">
          <span className="login__logo">S</span>
          <span className="login__brandText">StreetAdvise</span>
        </div>

        <h1 className="login__title">Sign in</h1>
        <p className="login__subtitle">Access the trading platform</p>

        <form className="login__form" onSubmit={handleSubmit}>
          <div className="login__field">
            <label className="login__label" htmlFor="username">Username</label>
            <input
              id="username"
              className="login__input"
              type="text"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="login__field">
            <label className="login__label" htmlFor="password">Password</label>
            <input
              id="password"
              className="login__input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="login__error">{error}</div>}

          <button className="login__btn" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
